// import { Component, OnDestroy, OnInit } from '@angular/core';
// import { Router } from '@angular/router';
// import { Subject, takeUntil } from 'rxjs';
// import { AcademicService } from 'src/app/services/academic.service';
// import { CommonService } from 'src/app/services/common.service';
// import { SecureSessionService } from 'src/app/services/secure-session.service';
// import { AcademicYearBadgeService } from 'src/app/services/academic-year-badge.service';

// @Component({
//   selector: 'app-academic-year-badge',
//   templateUrl: './academic-year-badge.component.html',
//   styleUrls: ['./academic-year-badge.component.scss']
// })
// export class AcademicYearBadgeComponent implements OnInit, OnDestroy {
//   private destroy$ = new Subject<void>();
  
//   academicYears: any;
//   sessionData: any;
//   schoolId = '';
//   academicYearId = '';
//   currentAcademicYear: any;
//   academicList: any[] = [];
//   selectedAcademicYearId: any = '';
//   isCurrentYear: boolean = true;
//   systemCurrentYearId: any = '';

//   constructor(
//     private session: SecureSessionService,
//     private _academic: AcademicService,
//     private _common: CommonService,
//     private router: Router,
//     private academicYearBadgeService: AcademicYearBadgeService
//   ) {
//     this.sessionData = JSON.parse(this.session.getSession());
//     this.schoolId = this.sessionData[0].schoolId;
//     this.academicYearId = this.sessionData[0].academicYearId;
//     this.selectedAcademicYearId = this.academicYearId;
//   }

//   ngOnInit(): void {
//     this.getAcademicYearById(this.academicYearId);
//     this.getAcademicYearData();
    
//     // ✅ Listen for external year switch requests
//     window.addEventListener('switchToActiveYear', this.handleSwitchToActiveYear);
//   }

//   ngOnDestroy(): void {
//     this.destroy$.next();
//     this.destroy$.complete();
//     this.academicYearBadgeService.hideWarning();
//     window.removeEventListener('switchToActiveYear', this.handleSwitchToActiveYear);
//   }

//   private handleSwitchToActiveYear = () => {
//     this.switchToCurrentYear();
//   }

//   getAcademicYearById(value: string | number): void {
//     this._academic.getAcademicYearById(value)
//       .pipe(takeUntil(this.destroy$))
//       .subscribe((res) => {
//         this.currentAcademicYear = res;
//       });
//   }

//   getAcademicYearData(): void {
//     this._academic.getAcademicYearList()
//       .pipe(takeUntil(this.destroy$))
//       .subscribe((res) => {
//         // ✅ Filter to show only active academic years
//         this.academicList = res.filter((year: any) => year.isActive === true);

//         // Find system current year
//         const systemCurrentYear = this.academicList.find(
//           (year: any) => year.isCurrentlyActive === true || year.setAsCurrentAcademicYear === true
//         );

//         if (systemCurrentYear) {
//           this.systemCurrentYearId = systemCurrentYear.academicYearId || systemCurrentYear.id;
//         }

//         // Find currently selected year
//         this.currentAcademicYear = this.academicList.find(
//           (year: any) => 
//             year.academicYearId === Number(this.academicYearId) || 
//             year.id === Number(this.academicYearId)
//         );

//         if (!this.currentAcademicYear && this.academicList.length > 0) {
//           this.currentAcademicYear = this.academicList.find((year: any) => year.isCurrentlyActive) || 
//                                       this.academicList[0];
//           this.selectedAcademicYearId = this.currentAcademicYear.academicYearId || this.currentAcademicYear.id;
//         }

//         // ✅ Initialize service state
//         this.updateServiceState();
//         this.checkIfCurrentYear();
//         this.updateWarningService();
//       });
//   }

//   onAcademicYearChange(event: any): void {
//     const selectedId = event.target.value;
    
//     if (!selectedId) return;

//     const selectedYear = this.academicList.find(
//       (year: any) => (year.academicYearId || year.id) === Number(selectedId)
//     );

//     if (!selectedYear) return;

//     this.selectedAcademicYearId = selectedId;
//     this.currentAcademicYear = selectedYear;
    
//     // ✅ Update session
//     this.updateSessionAcademicYear(selectedId, selectedYear);
    
//     // ✅ Update service state (replaces interceptor)
//     this.updateServiceState();
    
//     this.checkIfCurrentYear();
//     this.updateWarningService();

//     // ✅ Show notification
//     if (this.isCurrentYear) {
//       this._common.openSnackBar(`Switched to Active Academic Year: ${selectedYear.description}`);
//     } else {
//       this._common.openSnackBar(`Viewing Academic Year: ${selectedYear.description}`);
//     }

//     // ✅ Reload current page
//     this.reloadCurrentPage();
//   }

//   private updateSessionAcademicYear(yearId: string, yearData: any): void {
//     const currentSession = JSON.parse(this.session.getSession());
    
//     if (currentSession && currentSession.length > 0) {
//       currentSession[0].academicYearId = yearId;
//       currentSession[0].academicYear = yearData.description;
//       this.session.setSession(JSON.stringify(currentSession));
//       this.academicYearId = yearId;
//     }
//   }

//   // ✅ Update service state (replaces interceptor functionality)
//   private updateServiceState(): void {
//     this.academicYearBadgeService.updateAcademicYear({
//       academicYearId: this.selectedAcademicYearId,
//       academicYearName: this.currentAcademicYear?.description || '',
//       isCurrentYear: this.isCurrentYear,
//       schoolId: this.schoolId
//     });
//   }

//   private checkIfCurrentYear(): void {
//     this.isCurrentYear = Number(this.selectedAcademicYearId) === Number(this.systemCurrentYearId);
//   }

//   private updateWarningService(): void {
//     this.academicYearBadgeService.updateWarning({
//       show: !this.isCurrentYear,
//       yearName: this.currentAcademicYear?.description || '',
//       isActive: this.isCurrentYear
//     });
//   }

//   switchToCurrentYear(): void {
//     if (!this.systemCurrentYearId) {
//       this._common.openSnackBarError('Active academic year not found');
//       return;
//     }

//     const currentYear = this.academicList.find(
//       (year: any) => (year.academicYearId || year.id) === Number(this.systemCurrentYearId)
//     );

//     if (!currentYear) {
//       this._common.openSnackBarError('Active academic year data not found');
//       return;
//     }

//     this.selectedAcademicYearId = this.systemCurrentYearId;
//     this.currentAcademicYear = currentYear;
//     this.updateSessionAcademicYear(this.systemCurrentYearId, currentYear);
//     this.isCurrentYear = true;
    
//     // ✅ Update service state
//     this.updateServiceState();
//     this.updateWarningService();
    
//     this._common.openSnackBar(`Switched to Active Academic Year: ${currentYear.description}`);
//     this.reloadCurrentPage();
//   }

//   private reloadCurrentPage(): void {
//     const currentUrl = this.router.url;
//     this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
//       this.router.navigate([currentUrl]);
//     });
//   }

//   getAcademicYearId(year: any): any {
//     return year.academicYearId || year.id;
//   }
// }

import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AcademicService } from 'src/app/services/academic.service';
import { CommonService } from 'src/app/services/common.service';
import { SecureSessionService } from 'src/app/services/secure-session.service';
import { AcademicYearBadgeService } from 'src/app/services/academic-year-badge.service';

@Component({
  selector: 'app-academic-year-badge',
  templateUrl: './academic-year-badge.component.html',
  styleUrls: ['./academic-year-badge.component.scss']
})
export class AcademicYearBadgeComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  
  academicYears: any;
  sessionData: any;
  schoolId = '';
  academicYearId = '';
  currentAcademicYear: any;
  academicList: any[] = [];
  selectedAcademicYearId: any = '';
  isCurrentYear: boolean = true;
  systemCurrentYearId: any = '';

  constructor(
    private session: SecureSessionService,
    private _academic: AcademicService,
    private _common: CommonService,
    private router: Router,
    private academicYearBadgeService: AcademicYearBadgeService
  ) {
    this.sessionData = JSON.parse(this.session.getSession());
    this.schoolId = this.sessionData[0].schoolId;
    this.academicYearId = this.sessionData[0].academicYearId;
    this.selectedAcademicYearId = this.academicYearId;
  }

  ngOnInit(): void {
    this.getAcademicYearById(this.academicYearId);
    this.getAcademicYearData();
    
    // ✅ Listen for external year switch requests
    window.addEventListener('switchToActiveYear', this.handleSwitchToActiveYear);

    // ✅ Listen for data refresh triggers
    this.academicYearBadgeService.refreshData$
      .pipe(takeUntil(this.destroy$))
      .subscribe((shouldRefresh) => {
        if (shouldRefresh) {
          this.refreshAcademicYearData();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.academicYearBadgeService.hideWarning();
    window.removeEventListener('switchToActiveYear', this.handleSwitchToActiveYear);
  }

  private handleSwitchToActiveYear = () => {
    this.switchToCurrentYear();
  }

  getAcademicYearById(value: string | number): void {
    this._academic.getAcademicYearById(value)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.currentAcademicYear = res;
      });
  }

  getAcademicYearData(): void {
    this._academic.getAcademicYearList()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        // ✅ Filter to show only active academic years
        this.academicList = res.filter((year: any) => year.isActive === true);

        // Find system current year
        const systemCurrentYear = this.academicList.find(
          (year: any) => year.isCurrentlyActive === true || year.setAsCurrentAcademicYear === true
        );

        if (systemCurrentYear) {
          this.systemCurrentYearId = systemCurrentYear.academicYearId || systemCurrentYear.id;
        }

        // Find currently selected year
        this.currentAcademicYear = this.academicList.find(
          (year: any) => 
            year.academicYearId === Number(this.academicYearId) || 
            year.id === Number(this.academicYearId)
        );

        if (!this.currentAcademicYear && this.academicList.length > 0) {
          this.currentAcademicYear = this.academicList.find((year: any) => year.isCurrentlyActive) || 
                                      this.academicList[0];
          this.selectedAcademicYearId = this.currentAcademicYear.academicYearId || this.currentAcademicYear.id;
        }

        // ✅ Initialize service state
        this.updateServiceState();
        this.checkIfCurrentYear();
        this.updateWarningService();
      });
  }

  // ✅ New method to refresh academic year data
  private refreshAcademicYearData(): void {
    this._academic.getAcademicYearList()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        // Filter to show only active academic years
        this.academicList = res.filter((year: any) => year.isActive === true);

        // Find system current year
        const systemCurrentYear = this.academicList.find(
          (year: any) => year.isCurrentlyActive === true || year.setAsCurrentAcademicYear === true
        );

        if (systemCurrentYear) {
          this.systemCurrentYearId = systemCurrentYear.academicYearId || systemCurrentYear.id;
          
          // ✅ Auto-select newly activated/current year
          const sessionData = JSON.parse(this.session.getSession());
          const sessionYearId = sessionData[0].academicYearId;
          
          // Check if session year exists in active list
          const sessionYearExists = this.academicList.find(
            (year: any) => (year.academicYearId || year.id) === Number(sessionYearId)
          );

          if (sessionYearExists) {
            this.selectedAcademicYearId = sessionYearId;
            this.currentAcademicYear = sessionYearExists;
          } else {
            // If session year is not active, switch to system current year
            this.selectedAcademicYearId = this.systemCurrentYearId;
            this.currentAcademicYear = systemCurrentYear;
            
            // Update session
            this.updateSessionAcademicYear(this.systemCurrentYearId, systemCurrentYear);
          }
          
          // Update service state
          this.updateServiceState();
          this.checkIfCurrentYear();
          this.updateWarningService();
        }
      });
  }

  // onAcademicYearChange(event: any): void {
  //   const selectedId = event.target.value;
    
  //   if (!selectedId) return;

  //   const selectedYear = this.academicList.find(
  //     (year: any) => (year.academicYearId || year.id) === Number(selectedId)
  //   );

  //   if (!selectedYear) return;

  //   this.selectedAcademicYearId = selectedId;
  //   this.currentAcademicYear = selectedYear;
    
  //   // ✅ Update session
  //   this.updateSessionAcademicYear(selectedId, selectedYear);
    
  //   // ✅ Update service state (replaces interceptor)
  //   this.updateServiceState();
    
  //   this.checkIfCurrentYear();
  //   this.updateWarningService();

  //   // ✅ Show notification
  //   if (this.isCurrentYear) {
  //     this._common.openSnackBar(`Switched to Active Academic Year: ${selectedYear.description}`);
  //   } else {
  //     this._common.openSnackBar(`Viewing Academic Year: ${selectedYear.description}`);
  //   }

  //   // ✅ Reload current page
  //   this.reloadCurrentPage();
  // }
  onAcademicYearChange(event: any): void {
  const selectedId = event.target.value;
  
  if (!selectedId) return;

  const selectedYear = this.academicList.find(
    (year: any) => (year.academicYearId || year.id) === Number(selectedId)
  );

  if (!selectedYear) return;

  this.selectedAcademicYearId = selectedId;
  this.currentAcademicYear = selectedYear;
  
  // ✅ Update session
  this.updateSessionAcademicYear(selectedId, selectedYear);
  
  // ✅ Update service state (replaces interceptor)
  this.updateServiceState();
  
  this.checkIfCurrentYear();
  this.updateWarningService();

  // ✅ Show notification
  if (this.isCurrentYear) {
    this._common.openSnackBar(`Switched to Active Academic Year: ${selectedYear.description}`);
  } else {
    this._common.openSnackBar(`Viewing Academic Year: ${selectedYear.description}`);
  }

  // ✅ Reload current page with slight delay for session update
  setTimeout(() => {
    this.reloadCurrentPage();
  }, 100);
}

  private updateSessionAcademicYear(yearId: string, yearData: any): void {
    const currentSession = JSON.parse(this.session.getSession());
    
    if (currentSession && currentSession.length > 0) {
      currentSession[0].academicYearId = yearId;
      currentSession[0].academicYear = yearData.description;
      this.session.setSession(JSON.stringify(currentSession));
      this.academicYearId = yearId;
    }
  }

  // ✅ Update service state (replaces interceptor functionality)
  private updateServiceState(): void {
    this.academicYearBadgeService.updateAcademicYear({
      academicYearId: this.selectedAcademicYearId,
      academicYearName: this.currentAcademicYear?.description || '',
      isCurrentYear: this.isCurrentYear,
      schoolId: this.schoolId
    });
  }

  private checkIfCurrentYear(): void {
    this.isCurrentYear = Number(this.selectedAcademicYearId) === Number(this.systemCurrentYearId);
  }

  private updateWarningService(): void {
    this.academicYearBadgeService.updateWarning({
      show: !this.isCurrentYear,
      yearName: this.currentAcademicYear?.description || '',
      isActive: this.isCurrentYear
    });
  }

  // switchToCurrentYear(): void {
  //   if (!this.systemCurrentYearId) {
  //     this._common.openSnackBarError('Active academic year not found');
  //     return;
  //   }

  //   const currentYear = this.academicList.find(
  //     (year: any) => (year.academicYearId || year.id) === Number(this.systemCurrentYearId)
  //   );

  //   if (!currentYear) {
  //     this._common.openSnackBarError('Active academic year data not found');
  //     return;
  //   }

  //   this.selectedAcademicYearId = this.systemCurrentYearId;
  //   this.currentAcademicYear = currentYear;
  //   this.updateSessionAcademicYear(this.systemCurrentYearId, currentYear);
  //   this.isCurrentYear = true;
    
  //   // ✅ Update service state
  //   this.updateServiceState();
  //   this.updateWarningService();
    
  //   this._common.openSnackBar(`Switched to Active Academic Year: ${currentYear.description}`);
  //   this.reloadCurrentPage();
  // }
  switchToCurrentYear(): void {
  if (!this.systemCurrentYearId) {
    this._common.openSnackBarError('Active academic year not found');
    return;
  }

  const currentYear = this.academicList.find(
    (year: any) => (year.academicYearId || year.id) === Number(this.systemCurrentYearId)
  );

  if (!currentYear) {
    this._common.openSnackBarError('Active academic year data not found');
    return;
  }

  this.selectedAcademicYearId = this.systemCurrentYearId;
  this.currentAcademicYear = currentYear;
  this.updateSessionAcademicYear(this.systemCurrentYearId, currentYear);
  this.isCurrentYear = true;
  
  // ✅ Update service state
  this.updateServiceState();
  this.updateWarningService();
  
  this._common.openSnackBar(`Switched to Active Academic Year: ${currentYear.description}`);
  
  // ✅ Reload current page with slight delay
  setTimeout(() => {
    this.reloadCurrentPage();
  }, 100);
}

  // private reloadCurrentPage(): void {
  //   const currentUrl = this.router.url;
  //   this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
  //     this.router.navigate([currentUrl]);
  //   });
  // }
  private reloadCurrentPage(): void {
    const currentUrl = this.router.url;

    // Bounce through a dummy route and back so the page re-resolves for the new year.
    // navigateByUrl (NOT navigate([...])) is required for the return trip: navigate()
    // treats each array element as a single path SEGMENT and percent-encodes it, so a
    // url carrying a query string came back as ".../applications%3Ftab%3Dfinalize",
    // matched no route and rendered the 404 page. navigateByUrl parses the whole url,
    // query string included.
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(currentUrl);
    });
  }

  getAcademicYearId(year: any): any {
    return year.academicYearId || year.id;
  }
}